import React from "react";
import HtmlContent from "./HtmlContent";
import { type, typeRichDescription, typeRichDescriptionCenter, typeRichDescriptionLight, typeRichDescriptionLightCenter } from "../lib/typography";

export default function SectionTitle({ eyebrow, title, subtitle, align = "left", light = false }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  const subtitleClass = light
    ? align === "center"
      ? `mt-4 ${typeRichDescriptionLightCenter}`
      : `mt-4 ${typeRichDescriptionLight}`
    : align === "center"
      ? `mt-4 ${typeRichDescriptionCenter}`
      : `mt-4 ${typeRichDescription}`;

  return (
    <div className={`max-w-3xl ${alignClass}`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
          <span className="w-10 h-0.5 bg-[#1e6fcf]" />
          <span className={`${type.eyebrow} ${light ? "text-[#aad4fa]" : "text-[#1758a8]"}`}>
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className={`mt-4 ${type.sectionTitle} ${light ? "text-white" : "text-[#0a1a2f]"}`}>
        {title}
      </h2>
      {subtitle && <HtmlContent html={subtitle} className={subtitleClass} />}
    </div>
  );
}
